import React from 'react'
import { useIntl } from 'react-intl'
import { NavigationWrapper } from './NavigationStyledComponents'
import NavigationTile from './NavigationTile/NavigationTile'
import { MdHelpOutline, MdMailOutline, MdPeopleOutline } from 'react-icons/md'

function Navigation() {
  const intl = useIntl()
  return (
    <NavigationWrapper>
      <NavigationTile
        Icon={MdHelpOutline}
        link="/hausmart/faq"
        text={intl.formatMessage({ id: 'navigation.faq' })}
      />
      <NavigationTile
        Icon={MdPeopleOutline}
        link="/hausmart/about"
        text={intl.formatMessage({ id: 'navigation.aboutUs' })}
      />
      <NavigationTile
        Icon={MdMailOutline}
        link="/hausmart/contact"
        text={intl.formatMessage({ id: 'navigation.contact' })}
      />
    </NavigationWrapper>
  )
}

Navigation.displayName = 'Navigation'

export default Navigation
